import { combineReducers, createStore, applyMiddleware } from 'redux';
import { loadState, saveState } from '../utils/localStorage';
import throttle from 'lodash.throttle';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import user from './user';
import ui from './ui';
import goals from './goals';
import notes from './notes';
import book from './book';

let middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  middleware = [...middleware, logger];
}

const middlewares = applyMiddleware(...middleware);

const rootReducer = combineReducers({
  user,
  ui,
  goals,
  notes,
  book
});

const persistedState = loadState();

const store = createStore(rootReducer, persistedState, middlewares);

store.subscribe(
  throttle(() => {
    const { loggedIn, userData } = store.getState().user;

    if (loggedIn === true && userData !== null) {
      saveState({
        user: store.getState().user,
        ui: store.getState().ui
      });
    }
  }, 1000)
);

export default store;



// WEBPACK FOOTER //
// ./src/reducers/index.js